import { FC } from 'react'

import { ArrowLeft } from 'common/icons'
import Link from 'common/typography/Link'

export type SubNavProps = {
  title?: string
  children?: React.ReactNode
  backLink?: string
}

const SubNavBar: FC<SubNavProps> = ({ title, children, backLink }) => {
  return (
    <div
      data-cy="subnav"
      className="box-border bg-coolGray-100 h-14 border-b border-solid border-coolGray-100 
    flex justify-center items-center"
    >
      <div
        className="flex justify-between items-center font-medium w-full p-4"
        style={{ maxWidth: '1300px' }}
      >
        <div className="flex items-center">
          {backLink ? (
            <Link to={backLink}>
              <ArrowLeft className="ml-5 mr-4" />
            </Link>
          ) : undefined}

          <h3 className="text-lg text-coolGray-800">{title}</h3>
        </div>
        <nav className="flex gap-8 text-sm text-coolGray-500">{children}</nav>
      </div>
    </div>
  )
}

export default SubNavBar
